import { createSlice, combineReducers } from "@reduxjs/toolkit";
import { login } from "../Actions/AuthUser";
import { getPermission } from "../Actions/RoleManagement";

const initialState = {
  userDetail: {},
};


// export let loggedInUserDetailsSlice = createSlice({
//   name: "loggedInUserDetailsSlice",
//   initialState,
//   reducers: {},
//   extraReducers: (builder) => {
//     builder.addCase(login.pending, (state) => {
//       state.status = "loading";
//     });
//     builder.addCase(
//       login.fulfilled,
//       (state, { payload }) => {
//         state.userDetail = payload?.data?.user;
//         state.status = "success";
//       }
//     );
//     builder.addCase(
//       login.rejected,
//       (state, { payload }) => {
//         state.userDetail = {};
//         state.status = "failed";
//       }
//     );
//   },
// });

export let getRolePermissionSlice = createSlice({
  name: "getRolePermissionSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPermission.pending, (state) => {
      state.status = "loading";
    });
    builder.addCase(
      getPermission.fulfilled,
      (state, { payload }) => {
        state.viewPermission = payload?.data?.response?.filter((ele) => ele?.view)?.map((e) => e?.sectionName);
        state.editPermission = payload?.data?.response?.filter((ele) => ele?.edit)?.map((e) => e?.sectionName);
        state.status = "success";
      }
    );
    builder.addCase(
      getPermission.rejected,
      (state, { payload }) => {
        state.userPermission = {};
        state.status = "failed";
      }
    );
  },
});
// Action creators are generated for each case reducer function
// export const {} = apiDemoSlice.actions;

export default combineReducers({
  // loggedInUserDetails: loggedInUserDetailsSlice.reducer,
  getRolePermission: getRolePermissionSlice.reducer,
});
